import { render, staticRenderFns } from "./customer-label.vue?vue&type=template&id=d06d0780&scoped=true&"
import script from "./customer-label.vue?vue&type=script&lang=js&"
export * from "./customer-label.vue?vue&type=script&lang=js&"
import style0 from "./customer-label.vue?vue&type=style&index=0&id=d06d0780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06d0780",
  null
  
)

export default component.exports